import axiosInstance from "../utils/axios";
 
export const educationLevelService = {
  fetchAllWithoutPaginate: async () => {
    const response = await axiosInstance.get("/education-level/all");
    return response.data;
  },
  fetchAll: async (params = {}) => {
    const response = await axiosInstance.get("/education-level", { params });
    return response.data;
  },
  findById: async (id) => {
    const response = await axiosInstance.get("/education-level/" + id);
    return response.data;
  },
  store: async (data) => {
    const response = await axiosInstance.post("/education-level", data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await axiosInstance.put(`/education-level/${id}`, data);
    return response.data;
  },
  delete: async (id) => {
    const response = await axiosInstance.delete(`/education-level/${id}`);
    return response.data;
  },
};
